/**
 * Extract a font definition to be loaded globally.
 *
 * @async
 * @param {String} name the name of the font to load
 * @returns A complete CSS-in-JS definition for a font,
 * ready to be injected into an Emotion Global component.
 *
 * Example:
 *
 * const myFont = await getFont("name-of-the-font");
 * return (
 *   <Global styles={{ '.some-class': myFont }} />
 * )
 *
 */
export async function getFont(name) {
  switch (name) {
    case "hackbracket":
      return await (await import("./hackbracket")).default;

    case "utility":
      return await (await import("./utility-links")).default;

    default:
      return null;
  }
}